declare const process: {
  env: Record<string, string | undefined>;
};

export const APP_VERSION = process.env.REACT_APP_VERSION;
